import { useRutilusQuery } from '@graphql/client/useRutilusQuery';
import { isDefined } from '@lib/arrays/isDefined';
import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';
import { IDisplayEntity } from '@app-types/post';
import { getCatchPostComments } from '@graphql/queries/rutilus/Catch';
import { Post } from '../../types/Post';
import type { PostComment } from '../../types/PostComment';

interface PostCommentsData {
  postCommentContent: string;
  postCommentDate: Date;
  postComments: PostComment[];
  isLoading: boolean;
  likedByCurrentUser: boolean;
  likesCount: number;
  postId: string;
  userAvatarUrl: string;
  userFishingSpotAndFish: string[];
  userId: string;
  userNickname: string;
  displayEntity?: IDisplayEntity | null;
}

export const usePostComments = (
  posts: Post[],
  currentPostId: string | undefined,
): PostCommentsData => {
  const { data, loading: isLoading } = useRutilusQuery(getCatchPostComments, {
    variables: { externalId: currentPostId, first: 10 },
  });
  const currentPost = posts.find(post => post._id === currentPostId);
  const currentPostText = currentPost?.text;
  const postCommentContent = currentPostText?.text ?? '';
  const createdAt = currentPost?.createdAt;
  const postCommentDate = new Date(createdAt);
  const postComments = getNodesFromConnection(data?.post.comments);
  const likedByCurrentUser = !!data?.post.likedByCurrentUser;
  const likesCount = data?.post.likesCount ?? 0;
  const postId = currentPost?._id ?? '';
  const user = currentPost?.user;
  const userAvatarUrl = user?.avatar?.url ?? '';
  const catchData = currentPost?.catch;
  const fishingWaterName = catchData?.fishingWater?.displayName; // todo get fishingwater from post as well
  const speciesName = catchData?.species?.displayName;
  const userFishingSpotAndFish = [fishingWaterName, speciesName].filter(isDefined);
  const userId = user?._id ?? '';
  const userNickname = user?.nickname ?? '';
  const displayEntity = currentPost?.displayEntity;

  return {
    postCommentContent,
    postCommentDate,
    postComments,
    displayEntity,
    isLoading,
    likedByCurrentUser,
    likesCount,
    postId,
    userAvatarUrl,
    userFishingSpotAndFish,
    userId,
    userNickname,
  };
};
